// app/javascript/controllers/type_assignment_add_controller.js
//
// Adds a task type or inspection type to a license type and renders the
// turbo_stream response. Posts over fetch rather than submitting a form: this
// control lives inside the license type form, where a nested <form> would be
// invalid markup and Turbo is disabled for descendants anyway.
import {Controller} from "stimulus";

export default class extends Controller {
    static get targets() {
        return ["select"];
    }

    add(event) {
        event.preventDefault();

        const typeId = this.selectTarget.value;
        if (!typeId) return;

        const dataset = this.element.dataset;
        const paramKey = dataset.typeAssignmentAddParamKeyValue;
        const body = new URLSearchParams();
        body.set(`${paramKey}[${dataset.typeAssignmentAddTypeParamValue}]`, typeId);
        body.set(`${paramKey}[${this._ownerTypeParam(paramKey)}]`, "LicenseType");
        body.set(`${paramKey}[${this._ownerIdParam(paramKey)}]`, dataset.typeAssignmentAddOwnerIdValue);

        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

        fetch(dataset.typeAssignmentAddUrlValue, {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Accept": "text/vnd.turbo-stream.html",
                "X-CSRF-Token": csrfToken
            },
            body: body.toString()
        }).then(response => {
            if (response.ok) return response.text();
            throw new Error("Add failed");
        }).then(html => {
            if (html) Turbo.renderStreamMessage(html);
        }).catch(error => {
            console.error("Type assignment add failed:", error);
        });
    }

    // task_type_assignment => task_typable_type, inspection_type_assignment => inspection_typable_type
    _ownerTypeParam(paramKey) {
        return `${paramKey.replace(/_type_assignment$/, "")}_typable_type`;
    }

    _ownerIdParam(paramKey) {
        return `${paramKey.replace(/_type_assignment$/, "")}_typable_id`;
    }
}
